module.exports = __webpack_public_path__ + "static/favicon-27246f7bab8ea9b930bb578405c84995.ico";